export const PAGE_SIZE = 100;
export const DEFAULT_SORT_ORDER = ['name,asc'];
